import { configureStore } from "@reduxjs/toolkit"

import appSlice from "@feature/slice/appSlice";
import { setStore } from "services/apiConfig";
import postSlice from "@feature/slice/postSlice";
import growthSlice from "@feature/slice/growthSlice"
import notificationsSlice from "../features/slice/notificationSlice";
import chatContactsSlice from '../features/slice/chatContactsSlice';
import eventsReducer from '../features/slice/eventsSlice';
import bicSlice from "../features/slice/bicSlice";



const store = configureStore({
    reducer: {
        app: appSlice,
        posts: postSlice,
        growth: growthSlice, // Ensure this matches useSelector
        notifications: notificationsSlice,
        chatContacts: chatContactsSlice,
        events: eventsReducer,
        bic: bicSlice,

    },
});

setStore(store);


export default store;